import {Injectable} from "@angular/core";
import {EmeaContractModel, emeaContractModelFactory} from "./emea-contract.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class EmeaContractService {
  private url: string = "/api/contract";

  getFormData(projectId: string): Promise<EmeaContractModel> {
    return this.http.get(`${this.url}?projectId=${projectId}`)
      .pipe(map(data => emeaContractModelFactory(data)))
      .toPromise();
  }

  uploadFormData(contract: EmeaContractModel, projectId: string): Promise<any> {
    return this.http.post(`${this.url}?projectId=${projectId}`, contract)
      .toPromise();
  }

  constructor(private http: HttpClient) {}
}
